import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import axios from "axios";

const Enquiry = () => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [loadingCountries, setLoadingCountries] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Primary API
        let response = await axios.get("https://restcountries.com/v3.1/all");
        if (!response.data || response.data.length === 0) {
          // Backup API if needed
          response = await axios.get("https://restcountries.com/v2/all");
        }

        const countryData = response.data.map((country) => ({
          code: country.cca2 || country.alpha2Code,
          name: country.name.common || country.name,
        }));

        setCountries(countryData.sort((a, b) => a.name.localeCompare(b.name)));
      } catch (error) {
        console.error("Error loading countries:", error);
      } finally {
        setLoadingCountries(false);
      }
    };

    fetchCountries();
  }, []);

  const validateEmail = () => {
    const emailInput = document.getElementById("email");
    const emailError = document.getElementById("emailError");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    emailError.textContent = emailRegex.test(emailInput.value)
      ? ""
      : "Invalid email address";
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Enquire Now" />

      <section className="pb-10">
        <header className="mb-6">
          <h1 className="font-titleFont text-2xl font-bold text-primeColor mb-2">
            Export / Import Business Enquiry Form
          </h1>
          <p className="text-base text-lightText">
            Submit your enquiry for international trading, export and import services.
            Our team will respond quickly with the required information.
          </p>
        </header>

        <form
          id="enquiryForm"
          action="https://formsubmit.co/45324d01f5e99f51ac067895dd740978"
          method="POST"
          className="grid grid-cols-1 gap-4"
        >
          {/* Company Info */}
          <div>
            <label htmlFor="companyName" className="font-semibold">
              Company Name:
            </label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div>
            <label htmlFor="name" className="font-semibold">
              Contact Person:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              required
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" className="font-semibold">
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={validateEmail}
              required
              className="w-full border px-3 py-2 rounded-md"
            />
            <p id="emailError" className="text-red-500 text-sm mt-1"></p>
          </div>

          {/* Phone */}
          <div>
            <label htmlFor="phone" className="font-semibold">
              Phone:
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          {/* Country */}
          <div>
            <label htmlFor="country" className="font-semibold">
              Country:
            </label>

            {loadingCountries ? (
              <p className="text-gray-500">Loading countries…</p>
            ) : (
              <select
                id="country"
                name="country"
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                className="w-full border px-3 py-2 rounded-md"
              >
                <option value="" disabled>
                  Select a country
                </option>
                {countries.map((c) => (
                  <option key={c.code} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </select>
            )}

            {selectedCountry && (
              <p className="text-sm text-gray-600 mt-1">
                You selected: {selectedCountry}
              </p>
            )}
          </div>

          {/* Product */}
          <div>
            <label htmlFor="product" className="font-semibold">
              Product of Interest:
            </label>
            <input
              type="text"
              id="product"
              name="product"
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div>
            <label htmlFor="quantity" className="font-semibold">
              Quantity in Ton:
            </label>
            <input
              type="number"
              id="quantity"
              name="quantity"
              className="w-full border px-3 py-2 rounded-md"
            />
          </div>

          <div>
            <label htmlFor="message" className="font-semibold">
              Additional Details:
            </label>
            <textarea
              id="message"
              name="message"
              rows="4"
              className="w-full border px-3 py-2 rounded-md"
            ></textarea>
          </div>

          {/* Hidden FormSubmit Settings */}
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_next" value="https://www.rkglobaltrader.com" />

          {/* Submit Button */}
          <button
            type="submit"
            className="bg-primeColor text-white font-semibold px-6 py-2 rounded-md hover:bg-black duration-300"
          >
            Submit Enquiry
          </button>
        </form>

        <div className="flex justify-center mt-6">
          <Link to="/">
            <button className="w-52 h-10 bg-primeColor text-white text-lg hover:bg-black duration-300 rounded-md">
              Explore More Products
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Enquiry;
